import { AdaptStorage } from "./storage";

export const LocalStorage = new AdaptStorage("adaptLocalStorage", window.localStorage);
